import React from "react";
import { useMitmcvc } from "./MitmcvcLayout";
import { PageHero, Section } from "./_shared";
import { Phone, Mail, MapPin, Clock, Send } from "lucide-react";

export default function Contact() {
  const data = useMitmcvc();
  const inst = data?.institute || {};
  const address = "एमआयटी कॅम्पस, सिडको एन-४, छत्रपती संभाजीनगर, महाराष्ट्र";
  const mapQuery = encodeURIComponent("MIT HSC Vocational MCVC Junior College CIDCO N-4 Aurangabad Chhatrapati Sambhajinagar");

  return (
    <div data-testid="mitmcvc-contact">
      <PageHero
        eyebrow="संपर्क"
        title="आमच्याशी बोला"
        sub="पालक, विद्यार्थी व उद्योग भागीदार आमच्या सिडको एन-४ मधील कॅम्पसला कोणत्याही कार्यालयीन दिवशी भेट देऊ शकतात. फोन किंवा ईमेलद्वारे आमच्या प्रवेश कक्षाशी संपर्क साधा."
      />
      <Section>
        <div className="grid md:grid-cols-[1.1fr_1fr] gap-8">
          <div className="space-y-4">
            <Row icon={<MapPin />} label="पत्ता">{address}</Row>
            {inst.admission_phone && (
              <Row icon={<Phone />} label="फोन">
                <a href={`tel:${inst.admission_phone.replace(/\s+/g, "")}`} className="hover:text-[#B45309]">{inst.admission_phone}</a>
              </Row>
            )}
            {inst.email && (
              <Row icon={<Mail />} label="ईमेल">
                <a href={`mailto:${inst.email}`} className="hover:text-[#B45309] break-all">{inst.email}</a>
              </Row>
            )}
            <Row icon={<Clock />} label="कार्यालयीन वेळ">
              सोमवार – शनिवार · सकाळी १०:०० ते सायं. ५:००<br />
              <span className="text-xs text-slate-500">सार्वजनिक सुट्ट्यांच्या दिवशी कार्यालय बंद असेल.</span>
            </Row>
            <div className="grid grid-cols-2 gap-3 pt-2">
              <a href={`tel:${(inst.admission_phone || "").replace(/\s+/g, "")}`} className="inline-flex items-center justify-center gap-2 bg-[#F59E0B] hover:bg-[#B45309] text-[#052E16] font-bold text-sm uppercase tracking-wider px-5 py-3.5 transition-colors" data-testid="mitmcvc-contact-call">
                <Phone size={14} /> फोन करा
              </a>
              <a href={`mailto:${inst.email || ""}`} className="inline-flex items-center justify-center gap-2 border-2 border-[#14532D] text-[#14532D] font-bold text-sm uppercase tracking-wider px-5 py-3.5 hover:bg-[#14532D] hover:text-white transition-colors" data-testid="mitmcvc-contact-email">
                <Send size={14} /> ईमेल पाठवा
              </a>
            </div>
          </div>
          <div>
            <div className="border border-amber-100 overflow-hidden aspect-[4/3] bg-slate-100">
              <iframe
                title="MIT MCVC Junior College — Map"
                src={`https://www.google.com/maps?q=${mapQuery}&output=embed`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="mitmcvc-contact-map"
              />
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
}

function Row({ icon, label, children }) {
  return (
    <div className="bg-white border border-amber-100 p-5 flex items-start gap-4">
      <div className="w-10 h-10 shrink-0 flex items-center justify-center bg-[#F59E0B]/15 text-[#B45309]">{icon}</div>
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-slate-500 font-bold">{label}</div>
        <div className="mt-1 text-sm text-slate-800 leading-relaxed">{children}</div>
      </div>
    </div>
  );
}
